import { useLoaded } from '../lib/useLoaded.ts';
import { LoadingNotice, EmptyNotice, ErrorNotice } from '../components/StateNotice.tsx';
import type { DataPort } from '../adapters/port.ts';

/** El estado sale de la evidencia. Sin evidencia enlazable no se afirma «conectada». */
export function Integrations({ port }: { port: DataPort }) {
  const i = useLoaded(() => port.integrations());
  return (
    <section>
      <p className="lede">Herramientas del ecosistema y su estado real de verificación.</p>
      {i.kind === 'loading' && <LoadingNotice what="las integraciones" />}
      {i.kind === 'error' && <ErrorNotice message={i.message} />}
      {i.kind === 'empty' && <EmptyNotice what="integraciones" />}
      {i.kind === 'ok' && (
        <ul className="integrations">
          {i.value.map((x) => (
            <li key={x.id} className="integration">
              <span className={`state state--${x.state}`}>{x.state}</span>
              <strong>{x.name}</strong> <span className="muted">· {x.category}</span>
              <div className="evidence">{x.evidence ? `Evidencia: ${x.evidence}` : 'Sin evidencia — no se afirma conexión.'}</div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
